module.exports = __webpack_public_path__ + "img/no_data.557c5b44.png";